import React, {Component} from 'react';
import global, {deviceIsMobile, onResizeEventName, screenDirectionIsLandscape} from "@public/Global";
import '@css/auto-screen.scss'
import {ConfigProvider, theme} from "antd";
import locale from 'antd/locale/zh_CN';
const { getDesignToken, useToken } = theme;
export default class AutoScreen extends Component {
    pageWidth=1280;
    state={
        screenDirectionIsLandscape:true
    };
    constructor(props, context) {
        super(props);
        this.onResize(false);
    }
    componentDidMount() {
        window.addEventListener(onResizeEventName, this.onResize, false);
        //window.screen.orientation.addEventListener('change', this.handleOrientationChange);

        //this.onResize();

    }
    onResize=(update=true)=>{
        let {pageWidth=this.pageWidth}=this.props;
        let {innerWidth,innerHeight}=window;
        let {app}=global;
        let size=16;
        let x=innerWidth;
        screenDirectionIsLandscape();
        if(!global.screenDirectionIsLandscape){
            x=innerHeight;
        }
        let pageScale=x/pageWidth;
        if(x<=1024){
            pageScale=1;
        }
        //pageScale=0.8;
        global.pageScale=pageScale;
        document.documentElement.style.fontSize=`${pageScale*size}px`;
        if(update){
            this.handleOrientationChange();
            app&&app.forceUpdate();
        }
    };

    handleOrientationChange=() => {
        let isScreenDirectionIsLandscape=global.screenDirectionIsLandscape;
        this.setState({screenDirectionIsLandscape:isScreenDirectionIsLandscape});
    }

    detectDeviceIsMobile() {
        return deviceIsMobile();
    }

    componentWillUnmount(){
        window.removeEventListener(onResizeEventName, this.onResize, false);
        //window.screen.orientation.removeEventListener('change', this.handleOrientationChange);
    }


    render() {
        let {children,useAuto=true}=this.props;
        let {screenDirectionIsLandscape}=this.state;

        return (
            <div className={`auto-screen ${this.detectDeviceIsMobile()?'device-mobile':'device-pc'} ${useAuto?((screenDirectionIsLandscape)?'landscape':'portrait'):''}`}>
                {children}
            </div>
        )
    }
}
